import { DefaultOpportunitiesComponent } from "./components/opportunities/templates/default/default-opportunities.component";
import { SocialOpportunitiesComponent } from "./components/opportunities/templates/social/social-opportunities.component";

export const oppComponentDef = {
    "opportunity-list": {
        "default": DefaultOpportunitiesComponent,
        "social": SocialOpportunitiesComponent
    }
}